import {hasNLO} from 'notebook/TypePredicates';
import {Note, NoteLinkedObject, NotePart} from 'notebook/util/NoteUtilConstants';

import inspectAllNoteParts from './inspectAllNoteParts';

export default function getNoteLinkedObjectsOfTypes(
  note: Note,
  types: Array<string>
): Array<NoteLinkedObject> {
  return getNoteLinkedObjectsOfTypesFromNoteParts(note.noteParts, types);
}

export function getNoteLinkedObjectsOfTypesFromNoteParts(
  noteParts: Array<NotePart>,
  types: Array<string>
): Array<NoteLinkedObject> {
  const noteLinkedObjects: Array<NoteLinkedObject> = [];
  inspectAllNoteParts(noteParts, (notePart) => {
    if (hasNLO(notePart) && types.includes(notePart.item.type)) {
      noteLinkedObjects.push(notePart.item);
    }
  });
  return noteLinkedObjects;
}
